import { Component } from "react";
import { connect } from "react-redux";

export const mapStateToEPQueryParams = ({ policyReducer = {} }) => {
    const selectedPolicy = policyReducer.selectedPolicy;
    return {
        policyNumber: selectedPolicy && selectedPolicy.EncryptedPolicyNumber,
        IVString: selectedPolicy && selectedPolicy.IVString,
    };
};

export class EPQueryParams extends Component {
    constructor(props) {
        super(props);
        this.state={
            ParamURL:"",
            URL:this.props.url
        };
        this.updatedURLEP = this.updatedURLEP.bind(this);
    }
    componentDidMount(){
        const params = new URL(this.state.URL);
        if(this.props.messageType !== undefined)
        {
            params.searchParams.append('messageType',this.props.messageType);
        } 
        params.searchParams.append('p',this.props.policyNumber);
        params.searchParams.append('iv',this.props.IVString);
        this.setState({
            ParamURL:params.href
         }, ()=>{
        this.updatedURLEP(this.state.ParamURL);
    });
    }
    updatedURLEP(url){
        this.props.updatedURL(url);
    }
    render() {   
    return null;
}
};

export default connect(mapStateToEPQueryParams)(EPQueryParams);